import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { useDeleteUsersApi, UserDTO, useSaveUsersApi } from '../../api/user-api';
import SvgDelete from '../../assets/icons/Delete';
import SvgSave from '../../assets/icons/Save';
import { notify } from '../../components/basic/notify';
import { T, translate } from '../../components/basic/text';
import { FormikTextField } from '../../components/formik';
import { BasicModal } from '../../components/basic/basic-modal';

export const ManageUserModal = ({
    show,
    user,
    allowEdit,
    onSave,
    onDeleted,
    onHide,
}: {
    show: boolean;
    user?: UserDTO;
    allowEdit: boolean;
    onSave: (user: UserDTO) => void;
    onDeleted: VoidFunction;
    onHide: VoidFunction;
}) => {
    const saveUsersApi = useSaveUsersApi();
    const deleteUsersApi = useDeleteUsersApi();
    if (!show) return <></>;

    const onSubmit = (values: UserDTO) =>
        saveUsersApi.post(null, values, ({ user }) => onSave(user), notify.error);
    const onDelete = () =>
        bd.msgbox(
            translate('delete-user'),
            translate('conform-delete-user'),
            [
                {
                    title: translate('delete'),
                    variant: 'contained',
                    color: 'secondary',
                    action: hide => {
                        deleteUsersApi.post(
                            { userName: user?.userName },
                            null,
                            () => {
                                hide();
                                onDeleted();
                            },
                            notify.error
                        );
                    },
                },
                {
                    title: translate('cancel'),
                    variant: 'outline',
                    color: 'secondary',
                },
            ],
            { className: 'modal-n', backdropClassName: 'modal-n' }
        );

    const initialValues = { ...(user || { userName: '' }) };
    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{user ? 'edit-user' : 'new-user'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    disabled={!formik.isValid || !allowEdit}
                                    variant="contained"
                                    onClick={formik.submitForm}
                                    className="min-w-80"
                                >
                                    <SvgSave />
                                    <T>save</T>
                                </bd.Button>
                                {!!user && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="outline"
                                        type="button"
                                        onClick={onDelete}
                                        color="secondary"
                                    >
                                        <SvgDelete className="size-sm" />
                                        <T>delete</T>
                                    </bd.Button>
                                )}
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="user-name"
                                inputMaxWidth="11rem"
                                name="userName"
                                handleEnter
                                type="text"
                                autoFocus
                                readOnly={!!user}
                            />
                            <FormikTextField
                                label="first-name"
                                inputMaxWidth="11rem"
                                name="firstName"
                                handleEnter
                                type="text"
                            />
                            <FormikTextField
                                label="last-name"
                                inputMaxWidth="11rem"
                                name="lastName"
                                handleEnter
                                type="text"
                            />
                            <FormikTextField
                                label="phone-number"
                                inputMaxWidth="11rem"
                                name="phoneNumber"
                                handleEnter
                                type="text"
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
};
